<form
  [formGroup]="form"
  [ngStyle]="{'width': width}"
  class="form-style"
>
  <mat-form-field
    appearance="fill"
    color="accent"
    class="candidate-input"
  >
    <mat-icon
      class="size-icon"
      matPrefix
    >search</mat-icon>
    <mat-label>{{label}}</mat-label>
    <input
      type="text"
      matInput
      [formControlName]="controlName"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      class="card"
      #auto="matAutocomplete"
      [displayWith]="getName"
    >
      <mat-option
        (click)="onSelectOption()"
        *ngFor="let user of getUsers((users$ | async)?.content)"
        [value]="user"
      >
        {{ user.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
